const navigation = {
  welcome: 'Добро Пожаловать!',
  rooms: 'Номера',
  dining: 'Ресторан',
  promotions: 'Специальные предложения',
  shanghai: 'Ресторан Shanghai',
  lavilla: 'Ресторан La Villa',
  footer: 'Контакты',
};

export default navigation;